// extracted by mini-css-extract-plugin
export default {"container":"_1hWeG","scrollBarColor":"_3KX9Z","cardContainer":"_2RGAf","listContainer":"nRx9f"};